export default __webpack_public_path__ + "static/image03-4ddb8f7a376c204ba0cc261f504c732c.webp";